module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main_container"
  }, [_c('el-tabs', {
    attrs: {
      "type": "border-card"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "撤除申请"
    }
  }, [_c('div', {
    staticClass: "view_mian"
  }, [_c('div', {
    staticClass: "title_sty"
  }, [_vm._v("申请人基本信息")]), _vm._v(" "), _c('el-row', {
    staticClass: "info_item",
    attrs: {
      "gutter": 10
    }
  }, [_c('el-col', {
    attrs: {
      "span": 5
    }
  }, [_c('div', {
    staticClass: "grid-content bg-purple info_title"
  }, [_c('img', {
    staticClass: "warn_icon",
    class: _vm.dataInfo.RequesterName.LastCheckStatus == 0 ? 'showIcon' : 'hideIcon',
    attrs: {
      "src": _vm.imgUrl,
      "alt": ""
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "i_style",
    class: _vm.dataInfo.RequesterName.ifShowspan ? 'show_i' : ''
  }, [_vm._v("+")]), _vm._v(" "), _c('span', {
    staticClass: "no_span",
    class: _vm.dataInfo.RequesterName.ifShowspan ? 'show_span' : '',
    on: {
      "click": function($event) {
        return _vm.unquailClick(_vm.dataInfo.RequesterName)
      }
    }
  }, [_vm._v("\n                            申请人姓名：\n                        ")])])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 16
    }
  }, [_c('div', {
    staticClass: "grid-content bg-purple-light info_con"
  }, [_vm._v(_vm._s(_vm.dataInfo.RequesterName.NodeValue))])])], 1), _vm._v(" "), _c('el-row', {
    staticClass: "info_item",
    attrs: {
      "gutter": 10
    }
  }, [_c('el-col', {
    attrs: {
      "span": 5
    }
  }, [_c('div', {
    staticClass: "grid-content bg-purple info_title"
  }, [_c('img', {
    staticClass: "warn_icon",
    class: _vm.dataInfo.RequesterPhoneNum.LastCheckStatus == 0 ? 'showIcon' : 'hideIcon',
    attrs: {
      "src": _vm.imgUrl,
      "alt": ""
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "i_style",
    class: _vm.dataInfo.RequesterPhoneNum.ifShowspan ? 'show_i' : ''
  }, [_vm._v("+")]), _c('span', {
    staticClass: "no_span",
    class: _vm.dataInfo.RequesterPhoneNum.ifShowspan ? 'show_span' : '',
    on: {
      "click": function($event) {
        return _vm.unquailClick(_vm.dataInfo.RequesterPhoneNum)
      }
    }
  }, [_vm._v("申请人电话：")])])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 16
    }
  }, [_c('div', {
    staticClass: "grid-content bg-purple-light info_con"
  }, [_vm._v(_vm._s(_vm.dataInfo.RequesterPhoneNum.NodeValue))])])], 1), _vm._v(" "), (_vm.commitType == '2') ? _c('el-row', {
    staticClass: "info_item",
    attrs: {
      "gutter": 10
    }
  }, [_c('el-col', {
    attrs: {
      "span": 5
    }
  }, [_c('div', {
    staticClass: "grid-content bg-purple info_title"
  }, [_c('img', {
    staticClass: "warn_icon",
    class: _vm.dataInfo.RequesterOrganisation.LastCheckStatus == 0 ? 'showIcon' : 'hideIcon',
    attrs: {
      "src": _vm.imgUrl,
      "alt": ""
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "i_style",
    class: _vm.dataInfo.RequesterOrganisation.ifShowspan ? 'show_i' : ''
  }, [_vm._v("+")]), _c('span', {
    staticClass: "no_span",
    class: _vm.dataInfo.RequesterOrganisation.ifShowspan ? 'show_span' : '',
    on: {
      "click": function($event) {
        return _vm.unquailClick(_vm.dataInfo.RequesterOrganisation)
      }
    }
  }, [_vm._v(" 所在单位：")])])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 16
    }
  }, [_c('div', {
    staticClass: "grid-content bg-purple-light info_con"
  }, [_vm._v(_vm._s(_vm.dataInfo.RequesterOrganisation.NodeValue))])])], 1) : _vm._e(), _vm._v(" "), (_vm.commitType == '2') ? _c('el-row', {
    staticClass: "info_item",
    attrs: {
      "gutter": 10
    }
  }, [_c('el-col', {
    attrs: {
      "span": 5
    }
  }, [_c('div', {
    staticClass: "grid-content bg-purple info_title"
  }, [_c('img', {
    staticClass: "warn_icon",
    class: _vm.dataInfo.PersonIdentification.LastCheckStatus == 0 ? 'showIcon' : 'hideIcon',
    attrs: {
      "src": _vm.imgUrl,
      "alt": ""
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "i_style",
    class: _vm.dataInfo.PersonIdentification.ifShowspan ? 'show_i' : ''
  }, [_vm._v("+")]), _c('span', {
    staticClass: "no_span",
    class: _vm.dataInfo.PersonIdentification.ifShowspan ? 'show_span' : '',
    on: {
      "click": function($event) {
        return _vm.unquailClick(_vm.dataInfo.PersonIdentification)
      }
    }
  }, [_vm._v(" 个人身份证明：")])])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 16
    }
  }, _vm._l((_vm.dataInfo.PersonIdentification.NodeValue), function(item) {
    return _c('div', {
      key: item.index,
      staticClass: "grid-content bg-purple-light info_con"
    }, [_c('div', {
      ref: 'indexImg_' + item.FileGuid,
      refInFor: true,
      attrs: {
        "id": 'indexImg_' + item.FileGuid
      }
    }, [_c('ul', {
      staticStyle: {
        "display": "inline-block"
      }
    }, [_c('li', {
      staticStyle: {
        "display": "inline-block"
      }
    }, [_c('span', [_vm._v(_vm._s(item.FileName))]), _c('a', {
      staticClass: "view_a",
      attrs: {
        "target": "_blank",
        "id": "test"
      },
      on: {
        "click": function($event) {
          return _vm.showImgFn(item.FileGuid)
        }
      }
    }, [_vm._v("查看"), _c('img', {
      attrs: {
        "xss": "removed",
        "data-original": _vm.authImgUrl + '/api/Common/GetOriginalFile?BatchID=' + item.FileGuid
      }
    })])])]), _vm._v(" "), _c('a', {
      staticClass: "download_a",
      attrs: {
        "href": _vm.authImgUrl + '/api/Common/GetOriginalFile?BatchID=' + item.FileGuid,
        "download": "个人身份证明",
        "title": "下载",
        "target": "_blank"
      }
    }, [_vm._v("\n                                下载\n                                ")])])])
  }), 0)], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "title_sty"
  }, [_vm._v("待撤文章信息")]), _vm._v(" "), _c('el-row', {
    staticClass: "info_item",
    attrs: {
      "gutter": 10
    }
  }, [_c('el-col', {
    attrs: {
      "span": 5
    }
  }, [_c('div', {
    staticClass: "grid-content bg-purple info_title"
  }, [_c('img', {
    staticClass: "warn_icon",
    class: _vm.dataInfo.ArticleName.LastCheckStatus == 0 ? 'showIcon' : 'hideIcon',
    attrs: {
      "src": _vm.imgUrl,
      "alt": ""
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "i_style",
    class: _vm.dataInfo.ArticleName.ifShowspan ? 'show_i' : ''
  }, [_vm._v("+")]), _c('span', {
    staticClass: "no_span",
    class: _vm.dataInfo.ArticleName.ifShowspan ? 'show_span' : '',
    on: {
      "click": function($event) {
        return _vm.unquailClick(_vm.dataInfo.ArticleName)
      }
    }
  }, [_vm._v("题目名称：")])])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 16
    }
  }, [_c('div', {
    staticClass: "grid-content bg-purple-light info_con"
  }, [_vm._v(_vm._s(_vm.dataInfo.ArticleName.NodeValue))])])], 1), _vm._v(" "), _c('el-row', {
    staticClass: "info_item",
    attrs: {
      "gutter": 10
    }
  }, [_c('el-col', {
    attrs: {
      "span": 5
    }
  }, [_c('div', {
    staticClass: "grid-content bg-purple info_title"
  }, [_c('img', {
    staticClass: "warn_icon",
    class: _vm.dataInfo.Author.LastCheckStatus == 0 ? 'showIcon' : 'hideIcon',
    attrs: {
      "src": _vm.imgUrl,
      "alt": ""
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "i_style",
    class: _vm.dataInfo.Author.ifShowspan ? 'show_i' : ''
  }, [_vm._v("+")]), _c('span', {
    staticClass: "no_span",
    class: _vm.dataInfo.Author.ifShowspan ? 'show_span' : '',
    on: {
      "click": function($event) {
        return _vm.unquailClick(_vm.dataInfo.Author)
      }
    }
  }, [_vm._v("作者：")])])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 16
    }
  }, [_c('div', {
    staticClass: "grid-content bg-purple-light info_con"
  }, [_vm._v(_vm._s(_vm.dataInfo.Author.NodeValue))])])], 1), _vm._v(" "), (_vm.commitType == '2') ? _c('el-row', {
    staticClass: "info_item",
    attrs: {
      "gutter": 10
    }
  }, [_c('el-col', {
    attrs: {
      "span": 5
    }
  }, [_c('div', {
    staticClass: "grid-content bg-purple info_title"
  }, [_c('img', {
    staticClass: "warn_icon",
    class: _vm.dataInfo.UnitIdentification.LastCheckStatus == 0 ? 'showIcon' : 'hideIcon',
    attrs: {
      "src": _vm.imgUrl,
      "alt": ""
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "i_style",
    class: _vm.dataInfo.UnitIdentification.ifShowspan ? 'show_i' : ''
  }, [_vm._v("+")]), _c('span', {
    staticClass: "no_span",
    class: _vm.dataInfo.UnitIdentification.ifShowspan ? 'show_span' : '',
    on: {
      "click": function($event) {
        return _vm.unquailClick(_vm.dataInfo.UnitIdentification)
      }
    }
  }, [_vm._v("单位允许撤除证明：")])])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 19
    }
  }, [_c('div', {
    staticClass: "grid-content bg-purple-light info_con"
  }, [_c('div', {
    ref: 'indexImg_' + _vm.dataInfo.UnitIdentification.NodeValue[0].FileGuid,
    attrs: {
      "id": 'indexImg_' + _vm.dataInfo.UnitIdentification.NodeValue[0].FileGuid
    }
  }, [_c('ul', {
    staticStyle: {
      "display": "inline-block"
    }
  }, [_c('li', {
    staticStyle: {
      "display": "inline-block"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.dataInfo.UnitIdentification.NodeValue[0].FileName))]), _c('a', {
    staticClass: "view_a",
    attrs: {
      "target": "_blank",
      "id": "test"
    },
    on: {
      "click": function($event) {
        return _vm.showImgFn(_vm.dataInfo.UnitIdentification.NodeValue[0].FileGuid)
      }
    }
  }, [_vm._v("查看"), _c('img', {
    attrs: {
      "xss": "removed",
      "data-original": _vm.authImgUrl + '/api/Common/GetOriginalFile?BatchID=' + _vm.dataInfo.UnitIdentification.NodeValue[0].FileGuid
    }
  })])])]), _vm._v(" "), _c('a', {
    staticClass: "download_a",
    attrs: {
      "href": _vm.authImgUrl + '/api/Common/GetOriginalFile?BatchID=' + _vm.dataInfo.UnitIdentification.NodeValue[0].FileGuid,
      "download": "单位允许撤除证明",
      "title": "下载",
      "target": "_blank"
    }
  }, [_vm._v("\n                            下载\n                            ")])])])])], 1) : _vm._e(), _vm._v(" "), _c('el-row', {
    staticClass: "info_item",
    attrs: {
      "gutter": 10
    }
  }, [_c('el-col', {
    attrs: {
      "span": 5
    }
  }, [_c('div', {
    staticClass: "grid-content bg-purple info_title"
  }, [_c('img', {
    staticClass: "warn_icon",
    class: _vm.dataInfo.CheckReport.LastCheckStatus == 0 ? 'showIcon' : 'hideIcon',
    attrs: {
      "src": _vm.imgUrl,
      "alt": ""
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "i_style",
    class: _vm.dataInfo.CheckReport.ifShowspan ? 'show_i' : ''
  }, [_vm._v("+")]), _c('span', {
    staticClass: "no_span",
    class: _vm.dataInfo.CheckReport.ifShowspan ? 'show_span' : '',
    on: {
      "click": function($event) {
        return _vm.unquailClick(_vm.dataInfo.CheckReport)
      }
    }
  }, [_vm._v("检测报告单：")])])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 19
    }
  }, [_c('div', {
    staticClass: "grid-content bg-purple-light info_con"
  }, [_c('div', {
    ref: 'indexImg_' + _vm.dataInfo.CheckReport.NodeValue[0].FileGuid,
    attrs: {
      "id": 'indexImg_' + _vm.dataInfo.CheckReport.NodeValue[0].FileGuid
    }
  }, [_c('ul', {
    staticStyle: {
      "display": "inline-block"
    }
  }, [_c('li', {
    staticStyle: {
      "display": "inline-block"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.dataInfo.CheckReport.NodeValue[0].FileName))]), _c('a', {
    staticClass: "view_a",
    attrs: {
      "target": "_blank",
      "id": "test"
    },
    on: {
      "click": function($event) {
        return _vm.showImgFn(_vm.dataInfo.CheckReport.NodeValue[0].FileGuid, 'pdf')
      }
    }
  }, [_vm._v("查看"), _c('img', {
    attrs: {
      "xss": "removed",
      "data-original": _vm.authImgUrl + '/api/Common/GetOriginalFile?BatchID=' + _vm.dataInfo.CheckReport.NodeValue[0].FileGuid
    }
  })])])]), _vm._v(" "), _c('a', {
    staticClass: "download_a",
    attrs: {
      "href": _vm.authImgUrl + '/api/Common/GetOriginalFile?BatchID=' + _vm.dataInfo.CheckReport.NodeValue[0].FileGuid,
      "download": "检测报告单",
      "title": "下载",
      "target": "_blank"
    }
  }, [_vm._v("\n                            下载\n                            ")])])])])], 1), _vm._v(" "), _c('el-row', {
    staticClass: "info_item",
    attrs: {
      "gutter": 10
    }
  }, [_c('el-col', {
    attrs: {
      "span": 5
    }
  }, [_c('div', {
    staticClass: "grid-content bg-purple info_title"
  }, [_c('img', {
    staticClass: "warn_icon",
    class: _vm.dataInfo.ArticleLocation.LastCheckStatus == 0 ? 'showIcon' : 'hideIcon',
    attrs: {
      "src": _vm.imgUrl,
      "alt": ""
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "i_style",
    class: _vm.dataInfo.ArticleLocation.ifShowspan ? 'show_i' : ''
  }, [_vm._v("+")]), _c('span', {
    staticClass: "no_span",
    class: _vm.dataInfo.ArticleLocation.ifShowspan ? 'show_span' : '',
    on: {
      "click": function($event) {
        return _vm.unquailClick(_vm.dataInfo.ArticleLocation)
      }
    }
  }, [_vm._v("待撤文章位置：")])])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 19
    }
  }, [_c('div', {
    staticClass: "grid-content bg-purple-light info_con"
  }, [_c('div', {
    ref: 'indexImg_' + _vm.dataInfo.ArticleLocation.NodeValue[0].FileGuid,
    attrs: {
      "id": 'indexImg_' + _vm.dataInfo.ArticleLocation.NodeValue[0].FileGuid
    }
  }, [_c('ul', {
    staticStyle: {
      "display": "inline-block"
    }
  }, [_c('li', {
    staticStyle: {
      "display": "inline-block"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.dataInfo.ArticleLocation.NodeValue[0].FileName))]), _c('a', {
    staticClass: "view_a",
    attrs: {
      "target": "_blank",
      "id": "test"
    },
    on: {
      "click": function($event) {
        return _vm.showImgFn(_vm.dataInfo.ArticleLocation.NodeValue[0].FileGuid)
      }
    }
  }, [_vm._v("查看"), _c('img', {
    attrs: {
      "xss": "removed",
      "data-original": _vm.authImgUrl + '/api/Common/GetOriginalFile?BatchID=' + _vm.dataInfo.ArticleLocation.NodeValue[0].FileGuid
    }
  })])])]), _vm._v(" "), _c('a', {
    staticClass: "download_a",
    attrs: {
      "href": _vm.authImgUrl + '/api/Common/GetOriginalFile?BatchID=' + _vm.dataInfo.ArticleLocation.NodeValue[0].FileGuid,
      "download": "待撤文章位置",
      "title": "下载",
      "target": "_blank"
    }
  }, [_vm._v("\n                            下载\n                            ")])])])])], 1), _vm._v(" "), _c('el-row', {
    staticClass: "info_item",
    attrs: {
      "gutter": 10
    }
  }, [_c('el-col', {
    attrs: {
      "span": 5
    }
  }, [_c('div', {
    staticClass: "grid-content bg-purple info_title"
  }, [_vm._v("申请提交时间：")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 19
    }
  }, [_c('div', {
    staticClass: "grid-content bg-purple-light info_con"
  }, [_vm._v(_vm._s(_vm.dataInfo.CreateTime))])])], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.ifShenHe),
      expression: "ifShenHe"
    }],
    staticClass: "shenhe_box"
  }, [_c('div', {
    staticClass: "title_sty"
  }, [_vm._v("审核意见")]), _vm._v(" "), _c('el-row', {
    staticClass: "info_item",
    attrs: {
      "gutter": 10
    }
  }, [_c('el-col', {
    attrs: {
      "span": 5
    }
  }, [_c('div', {
    staticClass: "grid-content bg-purple info_title"
  }, [_vm._v("审核结果：")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 19
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "400px !important"
    },
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.RequestReviewDto.Result),
      callback: function($$v) {
        _vm.$set(_vm.RequestReviewDto, "Result", $$v)
      },
      expression: "RequestReviewDto.Result"
    }
  }, _vm._l((_vm.options2), function(item) {
    return _c('el-option', {
      key: item.value,
      staticStyle: {
        "width": "400px"
      },
      attrs: {
        "label": item.label,
        "value": item.value,
        "disabled": item.disabled
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    staticClass: "info_item",
    attrs: {
      "gutter": 10
    }
  }, [_c('el-col', {
    attrs: {
      "span": 5
    }
  }, [_c('div', {
    staticClass: "grid-content bg-purple info_title"
  }, [_vm._v("审核意见：")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 19
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "400px",
      "font-size": "12px"
    },
    attrs: {
      "type": "textarea",
      "rows": 2,
      "placeholder": "请输入内容",
      "autosize": {
        minRows: 5
      }
    },
    model: {
      value: (_vm.addCommet),
      callback: function($$v) {
        _vm.addCommet = $$v
      },
      expression: "addCommet"
    }
  }), _vm._v(" "), (_vm.commitType == '2') ? _c('div', _vm._l((_vm.optionCommit), function(item, index) {
    return _c('ul', {
      key: item.id,
      staticClass: "checkBox_box"
    }, [_c('li', {
      staticClass: "checkBox_item",
      class: item.ifClick ? 'show_color' + item.id : 'hide_color' + item.id,
      on: {
        "click": function($event) {
          return _vm.adDCommit(item.commitItem, index, item)
        }
      }
    }, [_vm._v("\n                                        " + _vm._s(item.commitItem) + "\n                                    ")])])
  }), 0) : _c('div', _vm._l((_vm.optionCommit1), function(item, index) {
    return _c('ul', {
      key: item.id,
      staticClass: "checkBox_box"
    }, [_c('li', {
      staticClass: "checkBox_item",
      class: item.ifClick ? 'show_color' + item.id : 'hide_color' + item.id,
      on: {
        "click": function($event) {
          return _vm.adDCommit(item.commitItem, index, item)
        }
      }
    }, [_vm._v("\n                                        " + _vm._s(item.commitItem) + "\n                                    ")])])
  }), 0)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "btn_box"
  }, [_c('el-button', {
    staticClass: "reApply_btn backRecord_btn",
    attrs: {
      "type": "primary",
      "loading": _vm.loading
    },
    on: {
      "click": _vm.commitReviewFn
    }
  }, [_vm._v("确认提交")]), _vm._v(" "), _c('el-button', {
    staticClass: "backRecord_btn",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.backRecord
    }
  }, [_vm._v("返回待审核列表")])], 1)], 1)], 1)])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-35f47d40"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/checkerPages/viewInfo.vue
// module id = 1184
// module chunks = 1